// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__179zU","buttons":"PendingPaymentAlert_buttons__zkprb"};